import { LatestPostsGrid, LatestPostsSlider } from '@/components/latest-posts/LatestPostsGrid'

import type { LinkProps } from '@/types/types'

import { MainColumn, MainColumnLeft, MainColumnRight } from '../main-column/MainColumn'

type LatestPostsProps = {
  style?: 'grid' | 'slider'
  heading?: string
  title?: string
  titleTag?: string
  titleClass?: string
  text?: string
  button?: LinkProps | null

  postType?: string
  postIds?: number[]
  topic?: number[]
  market?: number[]
  solution?: number[]
  author?: number[]
  type?: number[]

  businessId?: number | null

  fallbackText?: string
}

export default async function LatestPosts({
  style = 'slider',

  heading,
  title,
  titleTag = 'h2',
  titleClass = 'h2',
  text,
  button,

  postType,
  postIds = [],
  topic = [],
  market = [],
  solution = [],
  author = [],
  type = [],

  businessId = null,
  fallbackText,
}: LatestPostsProps) {
  // Set default values if value is false
  postIds = postIds || []
  topic = topic || []
  market = market || []
  solution = solution || []
  author = author || []
  type = type || []

  if (!postType && !postIds && !postIds.length) {
    return null
  }

  const params = new URLSearchParams({
    post_type: postType || '',
    topic: topic.join(','),
    market: market.join(','),
    solution: solution.join(','),
    author: author.join(','),
    type: type.join(','),
    post_ids: postIds.join(','),
    per_page: '100',
    business: businessId?.toString() || '',
  })

  const url = `${process.env.NEXT_PUBLIC_WP_API_URL}/wp-json/jf-custom/v1/generate-latest-posts?${params.toString()}`
  // console.log('Latest posts endpoint:', url)

  const response = (await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })) as Response

  if (!response.ok) {
    return null
  }

  const posts = await response.json()

  // If there are no posts and no fallback text, return null
  if ((!posts || posts.length === 0) && !fallbackText) {
    return null
  }

  // If there are no posts and there is fallback text, return fallback text
  if (!posts || posts.length === 0) {
    return (
      <div className="component component--latest-posts">
        <div className="container">
          <p>{fallbackText}</p>
        </div>
      </div>
    )
  }

  const leftContent = {
    heading,
    title,
    titleTag,
    titleClass,
    text,
    button,
  }

  const hasLeftContent = heading || title || text || button

  const items =
    style === 'slider' ? (
      <LatestPostsSlider posts={posts} fullWidth={!hasLeftContent} />
    ) : (
      <LatestPostsGrid posts={posts} />
    )

  return (
    <div className="component component--latest-posts">
      {hasLeftContent ? (
        <MainColumn>
          <MainColumnLeft {...leftContent} />

          <MainColumnRight>{items}</MainColumnRight>
        </MainColumn>
      ) : (
        <div className="container">{items}</div>
      )}
    </div>
  )
}
